import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import CookingMethodModal from "./Components/CookingMethodModal";

export default function AdminCookingMethod()
{
    const [cookingMethods, setCookingMethods] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedCookingMethod, setSelectedCookingMethod] =
        useState<any>(null);

    const loadCookingMethods = async () => {

        const response =
            await api.get(
                '/cookingmethods'
            );

        setCookingMethods(
            response.data
        );
    };

    useEffect(() => {

        loadCookingMethods();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedCookingMethod
        ) {

            await api.post(

                `/cookingmethods/${selectedCookingMethod.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/cookingmethods',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedCookingMethod(
            null
        );

        loadCookingMethods();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this cooking method?'
            )
        ) {
            return;
        }

        await api.delete(
            `/cookingmethods/${id}`
        );

        loadCookingMethods();
    };

    const moveCookingMethodUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...cookingMethods];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setCookingMethods(
            updated
        );

        await api.post(
            '/cookingmethods/reorder',
            {
                cookingMethods:
                    updated.map(
                        (
                            cookingMethod,
                            position
                        ) => ({
                            id:
                            cookingMethod.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadCookingMethods();
    };

    const moveCookingMethodDown = async (
        index: number
    ) => {

        if (
            index >=
            cookingMethods.length - 1
        ) {
            return;
        }

        const updated =
            [...cookingMethods];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setCookingMethods(
            updated
        );

        await api.post(
            '/cookingmethods/reorder',
            {
                cookingMethods:
                    updated.map(
                        (
                            cookingMethod,
                            position
                        ) => ({
                            id:
                            cookingMethod.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadCookingMethods();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Cooking Methods
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedCookingMethod(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Cooking Method
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {cookingMethods.map(
                    (
                        cookingMethod,
                        index
                    ) => (

                        <tr
                            key={
                                cookingMethod.id
                            }
                        >

                            <td>
                                {
                                    cookingMethod.name
                                }
                            </td>

                            <td>
                                {
                                    cookingMethod.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveCookingMethodUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveCookingMethodDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedCookingMethod(
                                                cookingMethod
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                cookingMethod.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <CookingMethodModal

                    cookingMethod={
                        selectedCookingMethod
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
